import React from 'react';
import PropTypes from 'prop-types';

import Asterisk from '../Asterisk';
import Box from '../Box';
import Label from '../Label';
import DateTextField from './presenter';


const DateTextFieldWithLabel = (props) => {
  const {
    isRequired,
    label,
    setRef,
    ...rest
  } = props;

  return (
    <Box sx={{ width: '100%' }}>
      <Label
        sx={{
          color: 'fieldLabel',
          fontSize: 'font14',
          marginBottom: 'grid4',
        }}
      >
        {label}
        {isRequired && (
          <React.Fragment>
            {` `}
            <Asterisk />
          </React.Fragment>
        )}
      </Label>
      <DateTextField {...rest} isRequired={isRequired} ref={setRef} />
    </Box>
  );
};

DateTextFieldWithLabel.propTypes = {
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  setRef: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  value: PropTypes.string,
};

DateTextFieldWithLabel.defaultProps = {
  isRequired: undefined,
  onChange: undefined,
  setRef: undefined,
  value: undefined,
};

const DateTextFieldWithLabelWithRef = React.forwardRef((props, ref) => (
  <DateTextFieldWithLabel setRef={ref} {...props} />
));


export { DateTextFieldWithLabel };
export default DateTextFieldWithLabelWithRef;
